import hatsApi from '@/services/hatsApi'

export default {
  getReservationUsers (params, pageSize = '', page = '', sort = '') {
    let filter = params || []
    return hatsApi().get(`/system/reservation_users?filter=${JSON.stringify(filter)}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/ReservationPerson.js